import {
  Button,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Spin,
  Switch,
} from 'antd';
import { find, isEmpty, sortBy } from 'lodash';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import CityApi from '../../../functions/api/partner/CityApi';
import DistrictApi from '../../../functions/api/partner/DistrictApi';
import PartnerApi from '../../../functions/api/partner/PartnerApi';
import VehiclePartnerApi from '../../../functions/api/partner/VehiclePartner';
import BrandApi from '../../../functions/api/vehicle/BrandApi';
import ModelApi from '../../../functions/api/vehicle/ModelApi';
import { VEHICLE_TYPES } from '../../../functions/api/vehicle/TypeApi';
import VehicleApi from '../../../functions/api/vehicle/VehicleApi';
import MyUtil from '../../../functions/MyUtil';
import SelectBrands from '../../vehiclePartner/select/Brand';
import SelectModels from '../../vehiclePartner/select/Model';
import PricesAndQuantities from './../PricesAndQuantities';

const formItemLayout = {
  wrapperCol: { span: 24 },
  labelCol: { span: 24 },
};
class FormAddCar extends Component {
  constructor(props) {
    super(props);

    const { vhc_part_id } = this.props.match.params;

    const userInfo = reactLocalStorage.getObject('user.info');
    const partnerId = userInfo.user_part_id;

    this.state = {
      vhc_part_id: vhc_part_id,
      types: [],
      brands: [],
      models: [],
      versions: [],
      vhc_display: true,
      part_id: null,
      vhc_bran_id: null,
      isEdit: !!props.match.params.vhc_part_id,
      vehicle: [],
      isVersionActive: false,
      isModelActive: false,
      cities: [],
      districts: [],
      disableDistrict: true,
      partnerId,
      partnerName: '',
    };
  }

  formRef = React.createRef();

  componentDidMount = async () => {
    const { vhc_part_id, partnerId } = this.state;

    const partner = await PartnerApi.getById(partnerId);

    const brands = await BrandApi.getBrandByType(VEHICLE_TYPES.CAR);
    const models = await ModelApi.getModelByType(VEHICLE_TYPES.CAR);

    const listVehicle = await VehicleApi.getVehicles();
    const cities = await CityApi.getAll();
    const districts = await DistrictApi.getAll();

    this.listCar = listVehicle.filter(
      (vhc) => vhc.vhc_type_id === VEHICLE_TYPES.CAR
    );

    let vehicle = await VehiclePartnerApi.getDetailVehicleNoConverst(
      vhc_part_id
    );

    if (!isEmpty(vehicle.vhc_part_defa_prie)) {
      vehicle.vhc_bran_id = vehicle.vhc.vhc_bran_id;
      vehicle.vhc_modl_id = vehicle.vhc.vhc_modl_id;
    }

    this.setState({
      brands,
      models,
      vehicle,
      versions: this.listCar.slice(),
      cities,
      districts,
      partnerName: partner.part_name,
    });
  };

  onChangeCity = async (cityId) => {
    const { cities } = this.state;
    let districts;
    if (cityId) {
      districts = await DistrictApi.getDistrictByCityId(cityId);
    }
    const city = find(cities, { city_id: cityId });
    if (!isEmpty(city)) {
      this.formRef.current.setFieldsValue({
        vhc_part_lat: city.city_lat,
        vhc_part_lng: city.city_long,
        vhc_part_addr: null,
        vhc_part_addr_shor: null,
      });
    }

    if (isEmpty(districts)) {
      this.setState({
        disableDistrict: true,
      });
      this.formRef.current.setFieldsValue({
        district_id: null,
      });
    } else {
      this.setState({
        districts: districts,
        disableDistrict: false,
      });
    }
  };

  onChangeSelectBrand = async (brandId) => {
    if (brandId) {
      const models = await ModelApi.getModelByBrand(brandId);

      this.setState({ models, isModelActive: true, vhc_bran_id: brandId });
    }
  };

  onChangeModel = async (vehicleModelId) => {
    if (!vehicleModelId) {
      return;
    }

    const { listCar } = this;
    const versions = listCar.filter(
      (vhc) => vhc.vhc_modl_id === vehicleModelId
    );

    this.setState({ versions, isVersionActive: true });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: +event.target.value });
  };

  submitForm = async (values) => {
    const {
      brands,
      models,
      versions,
      cities,
      districts,
      partnerId,
      partnerName,
    } = this.state;
    let payload = {
      ...values,
      part_id: partnerId,
      part_name: partnerName,
    };

    const vhc_bran_name = find(brands, {
      vhc_bran_id: payload.vhc.vhc_bran_id,
    })?.vhc_bran_name;
    payload.vhc_bran_name = vhc_bran_name;

    const { vhc_modl_name } = models.find(
      (model) => model.vhc_modl_id === payload.vhc.vhc_modl_id
    );
    payload.vhc_modl_name = vhc_modl_name;

    const version = payload.vhc_id
      ? find(versions, { vhc_id: payload.vhc_id })
      : [];
    payload.vhc_name = version.vhc_name;

    const city = payload.city_id
      ? find(cities, { city_id: payload.city_id })
      : [];
    payload.city_name = city.city_name;

    payload.district_name = null;

    if (!isEmpty(districts)) {
      const district = payload.district_id
        ? find(districts, { district_id: payload.district_id })
        : [];
      payload.district_name = district.district_name;
    }

    await this.handleCreate(payload);
  };

  handleCreate = async (payload) => {
    const { isEdit, vehicle, vhc_part_id } = this.state;

    let vhc = {
      ...payload,
      vhc_name: payload.vhc_name || vehicle.vhc_name,
      part_id: +payload.part_id,
      part_name: payload.part_name || vehicle.part_name,
      vhc_bran_name: payload.vhc_bran_name || vehicle.vhc_bran_name,
      vhc_modl_name: payload.vhc_modl_name || vehicle.vhc_modl_name,

      vhc_part_year: +payload.vhc_part_year,

      vhc_part_defa_prie: +MyUtil.convertMoney(payload.vhc_part_defa_prie),
      vhc_partner_price_week: +MyUtil.convertMoney(
        payload.vhc_partner_price_week
      ),
      vhc_partner_price_month: +MyUtil.convertMoney(
        payload.vhc_partner_price_month
      ),
      vhc_partner_price_quarter: +MyUtil.convertMoney(
        payload.vhc_partner_price_quarter
      ),
      vhc_partner_price_year: +MyUtil.convertMoney(
        payload.vhc_partner_price_year
      ),
      vhc_partner_price_2hours: +MyUtil.convertMoney(
        payload.vhc_partner_price_2hours
      ),
      vhc_partner_price_4hours: +MyUtil.convertMoney(
        payload.vhc_partner_price_4hours
      ),
      vhc_partner_price_8hours: +MyUtil.convertMoney(
        payload.vhc_partner_price_8hours
      ),
      vhc_partner_price_12hours: +MyUtil.convertMoney(
        payload.vhc_partner_price_12hours
      ),
      vhc_partner_price_24hours: +MyUtil.convertMoney(
        payload.vhc_partner_price_24hours
      ),
      vhc_partner_price_2week: +MyUtil.convertMoney(
        payload.vhc_partner_price_2week
      ),
      vhc_partner_price_halfyear: +MyUtil.convertMoney(
        payload.vhc_partner_price_halfyear
      ),

      vhc_part_qaty_tota: +payload.vhc_part_qaty_tota,
      vhc_part_qaty_aval: +payload.vhc_part_qaty_aval,

      vhc_part_id: vehicle.vhc_part_id || vhc_part_id,
      vhc_part_depo: vehicle.vhc_part_depo,
      vhc_part_polc: vehicle.vhc_part_polc,
      vhc_part_prty: vehicle.vhc_part_prty,
      vhc_part_crta: vehicle.vhc_part_crta,

      vhc_part_del: vehicle.vhc_part_del,
    };

    let result = [];

    if (isEdit) {
      vhc.vhc_part_upda = new Date();
      result = await VehiclePartnerApi.editVehiclePartner(vhc);
      if (!result['message']) {
        message.success('Sửa xe đối tác thành công tác thành công');
        this.props.history.push('/vehicle-partner');
      } else {
        message.error('Lỗi');
      }
    } else {
      vhc.vhc_part_crta = new Date();
      result = await VehiclePartnerApi.createVehiclePartner(vhc);
      if (!result['message']) {
        message.success('Thêm xe đối tác thành công');
        this.props.history.push('/vehicle-partner');
      } else {
        message.error('Lỗi');
      }
    }
  };

  render() {
    const {
      versions,
      models,
      vehicle,
      isEdit,
      isVersionActive,
      isModelActive,
      cities,
      districts,
      disableDistrict,
    } = this.state;

    if (!vehicle.vhc_part_id && isEdit) {
      return <Spin />;
    }
    return (
      <div>
        <h3>{vehicle.vhc_part_id ? 'Sửa xe' : 'Thêm xe'}</h3>

        <Form
          {...formItemLayout}
          initialValues={vehicle}
          onFinish={this.submitForm}
          ref={this.formRef}
        >
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item name="city_id" label="Xe ở thành phố">
                <Select
                  showSearch
                  onChange={this.onChangeCity}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(cities, ['city_name']).map((c) => ({
                    value: c.city_id,
                    label: c.city_name,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="district_id" label="Xe ở quận/ huyện">
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(districts, ['district_name']).map((d) => ({
                    value: d.district_id,
                    label: d.district_name,
                  }))}
                  disabled={disableDistrict}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['vhc_part_addr']}
                label="Địa chỉ"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['vhc_part_addr_shor']}
                label="Địa chỉ thu gọn"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name={['vhc_part_lat']} label="Latitude">
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name={['vhc_part_lng']} label="Longitude">
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['vhc', 'vhc_bran_id']}
                label="Hãng xe"
                rules={[{ required: true }]}
              >
                <SelectBrands
                  onBrandChange={this.onChangeSelectBrand}
                  disabled={!!vehicle.vhc_part_id}
                  vehicleType={VEHICLE_TYPES.CAR}
                  selected={vehicle.vhc?.vhc_bran_id}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc', 'vhc_modl_id']}
                label="Dòng xe"
                rules={[{ required: true }]}
              >
                <SelectModels
                  models={models}
                  onChange={this.onChangeModel}
                  disabled={!!vehicle.vhc_part_id || !isModelActive}
                  vehicleType={VEHICLE_TYPES.CAR}
                  selected={vehicle.vhc?.vhc_modl_id}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc_id']}
                label="Version"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(versions, ['vhc_name']).map((b) => ({
                    value: b.vhc_id,
                    label: b.vhc_name,
                  }))}
                  disabled={!!vehicle.vhc_part_id || !isVersionActive}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['vhc_part_year']}
                label="Năm sản xuất"
                rules={[{ required: true }]}
              >
                <Input
                  onChange={this.handleChange}
                  disabled={!!vehicle.vhc_part_id}
                />
              </Form.Item>
            </Col>
            <PricesAndQuantities onChange={this.handleChange} />
          </Row>
          <Form.Item
            label="Ẩn xe"
            name={['vhc_part_hide']}
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          <Space>
            <Button htmlType="submit" type="primary">
              Lưu
            </Button>
            <Button
              onClick={() => this.props.history.push('/vehicle-partner')}
              type="default"
            >
              Quay lại
            </Button>
          </Space>
        </Form>
      </div>
    );
  }
}

export default withRouter(FormAddCar);
